// frontend/src/components/reports/Reports.js

import React, { useEffect, useState } from "react";
import {
  fetchReportSummary,
  fetchFilteredTasks,
  exportReport,
} from "../../services/reportService";
import ReportFilters from "./ReportFilters";
import ReportSummaryCards from "./ReportSummaryCards";
import ReportTable from "./ReportTable";
import Charts from "./Charts";
import "../../styles/reports.css";

const Reports = () => {
  const [summary, setSummary] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSummary();
    handleFilterChange({});
  }, []);

  const loadSummary = async () => {
    try {
      console.log("📡 Fetching report summary...");
      const res = await fetchReportSummary();
      if (res?.data?.data) {
        setSummary(res.data.data);
        console.log("✅ Summary loaded:", res.data.data);
      } else {
        console.warn("⚠️ Unexpected summary format:", res);
      }
    } catch (error) {
      console.error("❌ Error loading report summary:", error);
    }
  };

  const handleFilterChange = async (newFilters) => {
    setFilters(newFilters);
    setLoading(true);
    try {
      console.log("📡 Fetching filtered tasks:", newFilters);
      const res = await fetchFilteredTasks(newFilters);
      const items = res?.data?.data?.items || [];
      setTasks(items);
      console.log("✅ Tasks loaded:", items.length);
    } catch (error) {
      console.error("❌ Error loading filtered tasks:", error);
      setTasks([]);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async (format) => {
    try {
      await exportReport(format, filters);
    } catch (error) {
      console.error("❌ Export failed:", error);
    }
  };

  return (
    <div className="reports-page">
      <h2 className="reports-title">📊 Reports & Analytics</h2>

      {summary ? (
        <>
          <ReportSummaryCards summary={summary} />

          <div className="report-charts-grid">
            <div className="report-chart-card">
              <Charts summary={summary} />
            </div>
          </div>
        </>
      ) : (
        <p>Loading summary...</p>
      )}

      <div className="report-filters-container">
        <div className="filter-controls">
          <ReportFilters onChange={handleFilterChange} />
        </div>

        <div className="export-controls">
          <button
            onClick={() => handleExport("xls")}
            className="btn btn-success"
          >
            ⬇️ Export Excel
          </button>
          <button
            onClick={() => handleExport("pdf")}
            className="btn btn-danger"
          >
            📄 Export PDF
          </button>
        </div>
      </div>

      <div className="report-table">
        <ReportTable tasks={tasks} loading={loading} />
      </div>
    </div>
  );
};

export default Reports;
